import createApi from './api';

export default class PayForPerformanceSettingsService {
  constructor() {
    this.api = createApi({
      baseUrl: 'admin/goals',
      headers: {
        'Content-Type': 'application/json'
      },
    });
  }

  async loadAll(params) {
    return this.api.post('list', params);
  }

  async update(params) {
    return this.api.post('update', params);
  }
}
